import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c559173")

_pushScopeId("data-v-4c559173")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "th-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Carryover From Last Year ")
const _hoisted_5 = { title: "Unused paid leave days are carried over to the January of the next year" }
const _hoisted_6 = { class: "th-container" }
const _hoisted_7 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.unavailableDays)
      ? (_openBlock(), _createBlock("table", _hoisted_1, [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              (_ctx.unavailableDays && _ctx.showCarryoverInfo)
                ? (_openBlock(), _createBlock("th", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _withDirectives(_createVNode("span", _hoisted_5, " ℹ️ ", 512), [
                        [_directive_tooltip]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (data, key) => {
                return (_openBlock(), _createBlock("th", { key: key }, [
                  _createVNode("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(data.header) + " ", 1),
                    (data.tooltip)
                      ? _withDirectives((_openBlock(), _createBlock("span", {
                          key: 0,
                          title: data.tooltip
                        }, " ℹ️ ", 8, ["title"])), [
                          [_directive_tooltip]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createVNode("tbody", null, [
            _createVNode("tr", null, [
              (_ctx.unavailableDays && _ctx.showCarryoverInfo)
                ? (_openBlock(), _createBlock("td", _hoisted_7, " ↪️ " + _toDisplayString(_ctx.unavailableDays.paid.carriedOverRemaining), 1))
                : _createCommentVNode("", true),
              _createVNode("td", null, "💰 " + _toDisplayString(_ctx.unavailableDays.paid.accepted), 1),
              _createVNode("td", null, "💰 " + _toDisplayString(_ctx.unavailableDays.paid.planned), 1),
              _createVNode("td", null, "⚡ " + _toDisplayString(_ctx.unavailableDays.unpaid.accepted), 1),
              _createVNode("td", null, "⚡ " + _toDisplayString(_ctx.unavailableDays.unpaid.planned), 1),
              _createVNode("td", null, "🕐 " + _toDisplayString(_ctx.unavailableDays.occasional.accepted), 1),
              _createVNode("td", null, "🕐 " + _toDisplayString(_ctx.unavailableDays.occasional.planned), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})